import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { callService, goTo } from "../tools";
import ModalSintillo from '../mensajes-tooltips/mensajes-tooltips.cmpt';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import TextField from 'material-ui/TextField';
import "./estilos-olv.css";
import { validarPass } from "../gnp-login/services.act";
import iconTimer from '../img/timer_24px.png';
import CampoFieldFrm from "../gnp-registro/campo-field.frm";
import moment from "moment";
import { authentication } from "../app-database";
import { servicios } from "./../properties";
import axios from 'axios';
import ModalClaveExpirado from "./modal-clave-caducada.cmpt";
import firebase from 'firebase';
import ModalOpcionesAyuda from "../../src/modal-ayuda/modal-opciones-ayuda.cmpt"
import BtnAyuda from "../gnp-registro/btn-ayuda.cmpt"
const idModalClave = "#modal-clave-temporal";
var totalSeconds = 1200000;
const TemporizadoClave = "TemporizadoClave";
const ojito = "eye-visible";
const ojitoCerrado = "eye-hidden";
const iconCircule = "icon-circle";
const iconCirculeDove = "icon-circle-dove";
const iconCirculeDovequis = "icon-equis-circulo"
const modalValidPass = "modal-validador-password";
const modalValidPassBody = "modal-validador-password-body";
const estiloCol = "col-md-6 col-sm-6 col-xs-12";
const estiloColpx = "0px 8px 0px 0px";
const colorNormal = "colorNormal";
const colorExito = "colorExito";
const colorError = "colorError";
let banderaExito = false;
let hash1 = "";

let claveTemporal = "";
const timeStamp = 0;
const mensajeItim = "Ocurrió un error inesperado, comunícate a la línea GNP 55 5227 9000 para más información.";
const robtenerNombreMedios = 'registro.obtenerNombreMedios';
let claveCaducado = false;
const aplication = 'application/json';
let tokenFirebase = "";

const mapState = (state) => {
	return {
		dispositivo: state.global.dispositivo,
		uid: state.recuperar.uid,
		estatus: state.recuperar.estatus,
		paso: state.recuperar.paso,
	};
};
const mapDispatch = (dispatch) => {
	return {
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		},
		loader: (show) => {
			dispatch({ "type": "LOADER", "show": show });
		},
		loginSecreto: (nombre) => {
			dispatch({ "type": "LOGIN_SET_SECRETO", "secreto": nombre });
		},
		loginserCliente: (clienteUnico) => {
			dispatch({ "type": "LOGIN_SET_CVECLIENTE", "cveCliente": clienteUnico });
		},
		loginIniciarSesionCorrecto: (dispositivo) => {
			dispatch({ "type": "EVENT_LOGIN_INICIARSESION_CORRECTOS", "flujo": "login", "dispositivo": dispositivo });
		},
		eventoCorrectos: (dispositivo) => {
			dispatch({ "type": "EVENT_LOGIN_BIENVENIDO_CORRECTOS", "flujo": "login", "dispositivo": dispositivo });
		},
		setPaso: (paso) => {
			dispatch({ "type": "PASO_SIGUIENTE_OLVIDE_CONTRASENIA", "paso": paso });
		}
	};
};
const campo = ({ input, label, type, param, max, fnToggle, clase, meta: { touched, error } }) => {
	return (
		<MuiThemeProvider>
			<TextField
				{...input}
				floatingLabelText={label}
				fullWidth={true}
				underlineStyle={{ borderColor: '#AAC3EE' }}
				underlineFocusStyle={{ borderColor: '#FF6B0B' }}
				floatingLabelStyle={floatingLabelStyleSettings}
				floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
				type={type}
				errorText={touched && error}
				maxLength={max}
				onChange={(event) => { input.onChange(event); }}
				onKeyPress={(event) => {
					if (event.key === 'Enter') {
						handleKeyPress(input);
					}
				}}
			/>
		</MuiThemeProvider>
	);
};
const handleKeyPress = (input) => {
	const inputs = document.getElementsByTagName('input');
	const inputActual = input.name;
	for (let index = 0; index < inputs.length; index++) {
		if (inputActual === inputs[index].name) {
			switch (input.name) {
				case "confpassword":
					document.getElementById(inputs[index].id).blur();
					break;
				case "password":
					document.getElementById(inputs[index + 1].id).focus();
					break;
				default:
					break;
			}
		}
	}
}
const campoSettings = {
	fontFamily: 'OpenSans',
	fontStyle: 'normal',
	fontWeight: 'normal',
	mixBlendMode: 'normal',
};
const floatingLabelStyleSettings = {
	...campoSettings,
	lineHeight: '16px',
	letterSpacing: '0.5px',
	color: '#33445F',
};
const floatingLabelFocusStyleSettings = {
	...campoSettings,
	lineHeight: '16px',
	letterSpacing: '0.4px',
	color: '#FF6B0B',
};
class PasswordForm extends React.Component {
	claseCaracteresCompletos = "";
	arrayCodigosOtp = [];
	datosUrl = [];
	btnHabilitado = false;
	state = {
		showValidatorPass: false,
		errorT: false,
		errorT2: false,
		caracteresCompletos: 'vacio',
		caracterMayuscula: 'vacio',
		caracterGNP: 'vacio',
		caracterConsecutivoIgual: 'vacio',
		caracterConsecutivo: 'vacio',
		espacioEnBlanco: 'vacio',
		caracteresAlfabeticos: 'vacio',
		caracteresNumericos: 'vacio',
		caracterEspecial: 'vacio',
		contraExitosa: false,
		btnHabilitado: 'deshabilita',
		showPass: true,
		showConfPass: true,
		showResp1: true,
		showResp2: true,
		password: "",
		confPassword: "",
		respuesta1: "",
		respuesta2: "",
		loadingPequeno: false,
		pregunta1: 0,
		pregunta2: 0,
		validate: {
			password: false,
			confPassword: false,
			respuesta1: false,
			respuesta2: false,
		},
		showTooltip: false,
		mensaje: "",
		type: "",
		titulo: "",
		modalClave: false,
		errorClave: false,
		MsjTiempoRestante: true,
		MsjExpira: false,
		msjErrorCodigo: false,
		msjExitoReenvio: false,
		msjErrorServicio: false,
		btnValidarHabilitado: true,
		uidEncriptado: "",
		email: "",
		cveUnico: "",
		errorsCodigo: false,
		msjaMostrar: "",
		showInput: true,
		name: "",
		label: "",
		modalTelefono: "",
		modalCorreo: ""
	}

	componentDidMount = () => {
		hash1 = localStorage.getItem("hash1");
		var URLactual = window.location;

		if (URLactual.href.toString().includes("recuperar-contrasenia-temporal-portal")) {
			axios({
				method: 'POST',
				url: servicios.utilerias.actualizaNodoRestablecer,
				headers: {
					'Content-Type': aplication,
					'Access-Control-Allow-Origin': '*',
					"valor": localStorage.getItem("hashThree"),
					"encripta": ''
				}
			}).then(response => {
				claveTemporal = response.data.hash;
				this.recuperarTemporal();
			});
		} else {
			this.recuperarNormal();
		}
	}

	recuperarDatos = () => {
		axios({
			method: 'POST',
			url: servicios.utilerias.actualizaNodoRestablecer,
			headers: {
				'Content-Type': aplication,
				'Access-Control-Allow-Origin': '*',
				"valor": localStorage.getItem("hashOne"),
				"encripta": ''
			}
		}).then(response => {
			const cveUnico = response.data.hash;
			new callService({
				service: robtenerNombreMedios,
				"secure": true,
				data: { cveCliente: cveUnico }
			}).execute().then(datos => {

				this.separaTelefono(datos.telefono);
				this.separaCorreo(datos.correo);
			}).catch(error => {
				console.log("erroresss", error);

			});
		});

	}
	recuperarTemporal = () => {

		this.recuperarDatos();

	}
	recuperarNormal = () => {

		if (localStorage.getItem("hashFour") !== undefined) {
			const origenPortalEnc = localStorage.getItem("hashFour");
			axios({
				method: 'POST',
				url: servicios.utilerias.actualizaNodoRestablecer,
				headers: {
					'Content-Type': aplication,
					'Access-Control-Allow-Origin': '*',
					"valor": origenPortalEnc,
					"encripta": ""
				}
			}).then(response => {
				localStorage.setItem("origenPortal", response.data.hash);
			});
		}
	}
	mostrarInput = (name?, type?, label?) => {
		setTimeout(() => {
			this.setState({ showInput: true, name: name, type: type, label: label });
		}, 300);
	}
	separaTelefono = (telefono) => {
		const ultimoD = telefono.substring(6, telefono.length);
		if (telefono !== "") {
			telefono = telefono.substring(0, 6);
			console.log("telefono", telefono);
			let element = "";
			for (let index = 0; index < telefono.length; index++) {
				element += '*';
			}
			this.setState({ modalTelefono: element + ultimoD });
		}

	}

	separaCorreo = (email) => {
		const dominio = email.substring(email.indexOf("@", 0), email.length)
		if (email !== "") {
			email = email.substring(0, email.indexOf("@", 0));
			let element = "";
			for (let index = 0; index < email.length - 5; index++) {
				element += '*';
			}

			this.setState({ modalCorreo: element + email.substring(email.length - 5, email.length) + dominio });
		} else {
			if (email !== "") {
				email = email.substring(0, email.indexOf("@", 0));
				let element = "";
				for (let index = 0; index < email.length - 5; index++) {
					element += '*';
				}

				this.setState({ modalCorreo: element + email.substring(email.length - 5, email.length) + dominio });
			}
		}
		this.props.loader(false);
		this.startTimer();
		$(idModalClave).modal({ backdrop: "static", keyboard: true });

	}
	viewPass = () => {
		this.setState({ showPass: !this.state.showPass });
	}
	viewPassConf = () => {
		this.setState({ showConfPass: !this.state.showConfPass });
	}
	lanzaErrorContra = (bandera) => {
		if (bandera) {
			setTimeout(() => {
				this.setState({ contraExitosa: bandera });
			}, 100);
		} else {
			this.setState({ contraExitosa: bandera });
		}
	}
	confirmPassword = () => {
		const valuePassword = document.getElementsByName('password')[0].value;
		const confirPassword = document.getElementsByName('confpassword')[0].value;
		if (confirPassword !== '' && valuePassword !== '') {
			if (valuePassword === confirPassword) {
				this.lanzaErrorContra(true);
				this.muestraTooltip(false);
				banderaExito = true;
			} else {
				this.lanzaErrorContra(false);
				this.muestraTooltip(true, 'error', 'Error', 'Las contraseñas no coinciden');
			}
		} else {
			if (confirPassword !== "") {
				this.setState({ errorT2: false });
			} else {
				this.setState({ errorT2: true });
			}
			banderaExito = false;
		}
	}
	muestraTooltip = (show, type?, titulo?, mensaje?) => {
		setTimeout(() => {
			this.setState({ showTooltip: show, type: type, titulo: titulo, mensaje: mensaje });
		}, 300);
	}
	cierraTooltip = e => {
		this.setState({
			showTooltip: !this.state.showTooltip
		});
	}
	validaPassword = () => {
		const valuePassword = document.getElementsByName('password')[0].value;
		function checkMayus(str) {
			return str.toLowerCase() !== str;
		}
		if (valuePassword === '') {
			this.setState({ caracteresCompletos: 'vacio' });
			this.setState({ caracterMayuscula: 'vacio' });
			this.setState({ caracterGNP: 'vacio' });
			this.setState({ caracterConsecutivoIgual: 'vacio' });
			this.setState({ espacioEnBlanco: 'vacio' });
			this.setState({ caracteresAlfabeticos: 'vacio' });
			this.setState({ caracteresNumericos: 'vacio' });
			this.setState({ caracterEspecial: 'vacio' });
			this.setState({ caracterConsecutivo: 'vacio' });
		} else {
			this.caracterConFunc(valuePassword);
			this.caracteresLetras(valuePassword);
			this.caracteresMayusLetra(valuePassword);
			this.caracteresAlfan(valuePassword);
			checkMayus(valuePassword) === false ? this.setState({ caracterMayuscula: 'error' }) : this.setState({ caracterMayuscula: 'exito' });
		}
		setTimeout(() => {
			this.validaBotonDeshabilitado();
		}, 300);
	}
	caracteresMayusLetra = (valuePassword) => {
		(/\s+/.test(valuePassword)) ? this.setState({ espacioEnBlanco: 'error' }) : this.setState({ espacioEnBlanco: 'exito' });
		valuePassword.length <= 7 || valuePassword.length > 24 ? this.setState({ caracteresCompletos: 'error' }) : this.setState({ caracteresCompletos: 'exito' });
		valuePassword.toLowerCase().includes("gnp") ? this.setState({ caracterGNP: 'error' }) : this.setState({ caracterGNP: 'exito' });
	}
	caracteresAlfan = (valuePassword) => {
		var contador = 0;
		var letras = "abcdefghyjklmnñopqrstuvwxyz";
		var letras_mayusculas = "ABCDEFGHYJKLMNÑOPQRSTUVWXYZ";
		for (var i = 0; i < valuePassword.length; i++) {
			if ((letras.indexOf(valuePassword.charAt(i), 0) !== -1) || letras_mayusculas.indexOf(valuePassword.charAt(i), 0) !== -1) {
				contador = contador + 1;
			} else {
				console.log('no existe alfabetico');
			}
		}
		if (contador >= 4) {
			this.setState({ caracteresAlfabeticos: 'exito' });
		} else {
			this.setState({ caracteresAlfabeticos: 'error' });
		}
	}
	caracterConFunc = (valuePassword) => {
		const ABC = "abcdefghijklmnopqrstuvwxyz", NUMEROS = "0123456789";
		for (var i = 0; i < valuePassword.length; i++) {
			var cadena = valuePassword.substr(i, 3).toLowerCase();
			if (cadena.length === 3 && (ABC.indexOf(cadena) >= 0 || NUMEROS.indexOf(cadena) >= 0)) {
				this.setState({ caracterConsecutivo: 'error' });
				break;
			} else {
				this.setState({ caracterConsecutivo: 'exito' });
			}
		}
		(/([\w])\1{2,}/.test(valuePassword)) ? this.setState({ caracterConsecutivoIgual: 'error' }) : this.setState({ caracterConsecutivoIgual: 'exito' });
	}
	caracteresLetras = (valuePassword) => {
		(/[0-9]/.test(valuePassword) === false) ? this.setState({ caracteresNumericos: 'error' }) : this.setState({ caracteresNumericos: 'exito' });
		(!/^[a-z0-9]+$/i.test(valuePassword)) ? this.setState({ caracterEspecial: 'exito' }) : this.setState({ caracterEspecial: 'error' });
	}
	validaBotonDeshabilitado = () => {
		console.log("validaBotonDeshabilitado contraEx", this.state.contraExitosa, "validaBotonDeshabilitado btnH", this.state.btnHabilitado);
	}
	validaCaracteresIcon = (value) => {
		if (this.state[value] === 'vacio') {
			return iconCircule;
		} else if (this.state[value] === 'exito') {
			return iconCirculeDove;
		} else {
			return iconCirculeDovequis;
		}
	}
	validaCaracteresColor = (value) => {
		if (this.state[value] === 'vacio') {
			return colorNormal;
		} else if (this.state[value] === 'exito') {
			return colorExito;
		} else {
			return colorError;
		}
	}
	handleFocusPassword = () => {
		this.setState({ showValidatorPass: true });
	}
	handleBlurPassword = () => {
		if (this.state.caracteresCompletos === 'exito' && this.state.caracterMayuscula === 'exito'
			&& this.state.caracteresAlfabeticos === 'exito'
			&& this.state.caracterGNP === 'exito' && this.state.espacioEnBlanco === 'exito' && this.state.caracterConsecutivoIgual === 'exito'
			&& this.state.caracteresNumericos === 'exito' && this.state.caracterEspecial === 'exito'
			&& this.state.caracterConsecutivo === 'exito') {
			this.setState({ showValidatorPass: false });
		} else {
			this.setState({ showValidatorPass: true });
		}
		this.validaPasswordConfirm();
		const valuePassword = document.getElementsByName('password')[0].value;
		if (valuePassword !== "") {
			this.setState({ errorT: false });
		} else {
			this.setState({ errorT: true });
		}
	}
	validaPasswordConfirm = () => {
		const confpassword = document.getElementsByName('confpassword')[0].value;
		if (confpassword !== '') {
			this.confirmPassword();
		}
	}
	toggle = (sParam) => {
		this.setState({ [sParam]: !this.state[sParam] });
	}
	ir = () => {
		this.props.loader(true);
		const valuePassword = document.getElementsByName('password')[0].value;
		axios({
			method: 'POST',
			url: servicios.utilerias.actualizaNodoRestablecer,
			headers: {
				'Content-Type': aplication,
				'Access-Control-Allow-Origin': '*',
				"valor": hash1,
				"encripta": ""
			}
		}).then(response => {
			new callService({
				service: "registro.obtenerNombreMedios",
				"secure": true,
				data: { cveCliente: hash1 }
			}).execute().then(datos => {
				const origenP = localStorage.getItem("origenPortal");
				if (origenP === "true") {
					localStorage.removeItem("hashOne");
					localStorage.removeItem("hashTwo");
					localStorage.removeItem("hashThree");
					localStorage.removeItem("contador");
					localStorage.removeItem("claveValido");
					this.props.loginIniciarSesionCorrecto(this.props.dispositivo);
					this.props.loginserCliente(datos.cveClienteUnico);
					this.props.loginSecreto(datos.nombre);
					this.mandaPassword(datos.cveClienteUnico, datos.correo, valuePassword);
					this.esconderModal();
				} else {
					new callService({
						service: robtenerNombreMedios,
						"secure": true,
						data: { cveCliente: hash1 }
					}).execute().then(datosF => {
						axios({
							method: 'POST',
							url: servicios.utilerias.actualizaNodoRestablecer,
							headers: {
								'Content-Type': aplication,
								'Access-Control-Allow-Origin': '*',
								"valor": datosF.correo,
								"encripta": true
							}
						}).then(response1 => {
							axios({
								method: 'POST',
								url: servicios.utilerias.actualizaNodoRestablecer,
								headers: {
									'Content-Type': aplication,
									'Access-Control-Allow-Origin': '*',
									"valor": valuePassword,
									"encripta": true
								}
							}).then(response2 => {
								const urlN = servicios.dominioReingenieria + "?correo=" + response1.data.hash + "&pass=" + response2.data.hash;
								window.location.assign(urlN);
								this.esconderModal();
							}).catch(error => {
								console.log("erroras", error);
							});
						}).catch(error => {
							console.log("errordd", error);
						});
					}).catch(error => {
						console.log("erroresss", error);
						this.errorServicio("login bienvenido");
					});
				}
			}).catch(error => {
				console.log("errorrrrr", error);
				this.errorServicio("obtenerNombreMedios");
			});
		});
	}
	esconderModal = () => {
		$("#modal-exito").modal("hide");
	}
	errorServicio = (tipo) => {
		this.props.loader(false);
		this.muestraTooltip(true, 'error', "error", "Ocurrio un problema con el servicio ");
		this.esconderModal();
		this.regreso();
	}
	regreso = () => {
		firebase.database().ref("portales/portalReingenieria").once("value").then(oValue => {
			var data = oValue.val();
			if (!data) {
				goTo("login");
			} else {
				window.location.assign(servicios.dominioReingenieria);
			}
		})
	}
	mandaPassword = (cliente, correo, pass) => {
		const $this = this;
		validarPass(cliente, correo, pass).then((response) => response.json()).then((responseJson) => {
			if (responseJson.hasOwnProperty("jwt")) {
				authentication.signInWithCustomToken(responseJson.jwt).then(function (result) {
					localStorage.setItem("refreshToken", responseJson.refreshtoken);
					$this.props.eventoCorrectos($this.props.dispositivo);
					goTo("home")
					$this.props.tagManager({
						"type": "EVENT_LOGIN_INICIAR_SESION", "dispositivo": this.props.dispositivo, "ramo": localStorage.getItem("ramo")
					});
					$this.props.loader(false);
				}).catch(function (error) {
					console.log("autenticacion", error);
					this.regreso();
					$this.props.loader(false);
				});
			} else {
				console.log('error');
				this.regreso();
				$this.props.loader(false);
			}
		})
	}
	siguiente = () => {
		const valuePassword = document.getElementsByName('password')[0].value;
		const valueConfPassword = document.getElementsByName('confpassword')[0].value;
		if (valuePassword !== valueConfPassword) {
			console.log("Las contraseñas no coinciden");
		} else {
			this.encriptaPass();
		}
	}
	encriptaPass = () => {
		const valuePassword = document.getElementsByName('password')[0].value;
		axios({
			method: 'POST',
			url: servicios.utilerias.actualizaNodoRestablecer,
			headers: {
				'Content-Type': aplication,
				'Access-Control-Allow-Origin': '*',
				"valor": valuePassword,
				"encripta": true
			}
		}).then(response => {
			this.siguiente2(response.data.hash);
		}).catch(error => {
			console.log("errorSS", error);
		});
	}
	siguiente2 = (pass) => {
		tokenFirebase = localStorage.getItem("hashFive");
		if (banderaExito === true && !this.state.loadingPequeno) {
			this.setState({ loadingPequeno: true });
			const objService = {
				"uid": localStorage.getItem("hashOne"),
				"dato": true
			}
			new callService({ service: "login.desbloqueoMedios", secure: true, data: { "uid": localStorage.getItem("hashOne") } }).execute();
			new callService({ service: "olvideContrasena.aceptoConfidencialidad", secure: true, data: objService }).execute();
			new callService({ service: "olvideContrasena.aceptoContrato", secure: true, data: objService }).execute();
			new callService({
				service: 'olvideContrasena.actualizarPassword',
				"secure": true,
				data: {
					"uid": localStorage.getItem("hashOne"),
					"pass": pass,
					"token": tokenFirebase
				}
			}).execute().then(body => {
				this.setState({ loadingPequeno: false });
				if (body.restablecerContrasenaClienteResponse.banExito === true) {
					this.muestraModalExito = true;
					$("#modal-exito").modal({ backdrop: "static", keyboard: true });
				}
			}).catch(error => {
				this.setState({ loadingPequeno: false });
				console.log("ERROR", error);
				if (error.message.codigoError.includes("ITIM")) {
					this.muestraTooltip(true, 'error', validacion, mensajeItim);
				} else if (error.message.codigoError === 'eCl00026') {
					this.muestraTooltip(true, 'error', 'ERROR', "Lo sentimos, por su seguridad no puede introducir contraseñas anteriores.");
				}
			});
		} else {
			this.setState({ errorT: true });
			console.log("Son diferentes", this.errorT);
		}
	}

	codigoCompleto = () => {
		const inputCodigo = document.getElementsByName('codigo_verificacion')[0].value;
		if (inputCodigo.length === 8) {
			this.setState({ msjaMostrar: "" });
			this.setState({ errorsCodigo: false });
			this.validarClaveAcceso(inputCodigo);
		} else {
			this.setState({ msjaMostrar: "La clave debe tener 8 caracteres" });
			this.setState({ errorsCodigo: true });
			this.setState({ btnValidarHabilitado: false })
		}
	}
	quitarMsjTiempoRestante = (bandera) => {
		if (bandera) {
			setTimeout(() => {
				this.setState({ MsjTiempoRestante: bandera })
			}, 100);
		} else {
			this.setState({ MsjTiempoRestante: bandera })
		}
	}
	quitarMsjErrorCodigo = (bandera) => {
		if (bandera) {
			setTimeout(() => {
				this.setState({ msjErrorCodigo: bandera })
			}, 1000);
		} else {
			this.setState({ msjErrorCodigo: bandera })
		}
	}
	quitarmsjReenvio = (bandera) => {
		if (bandera) {
			setTimeout(() => {
				this.setState({ msjExitoReenvio: true })
			}, 500);
		} else {
			setTimeout(() => {
				this.setState({ msjExitoReenvio: false })
			}, 500);
		}
	}
	quitarmsjErrorServicio = (bandera) => {
		if (bandera) {
			setTimeout(() => {
				this.setState({ msjErrorServicio: bandera })
			}, 500);
		} else {
			this.setState({ msjErrorServicio: bandera })
		}
	}
	validarClaveAcceso = (clave) => {
		if (claveTemporal !== clave) {
			this.setState({ errorsCodigo: true });
			this.setState({ msjaMostrar: "El código no coincide" });
		} else {
			localStorage.setItem("claveValido", "true");
			$(idModalClave).modal("hide");
		}
	}
	startTimer = () => {
		var tiempo = localStorage.getItem("hashTwo");
		axios({
			method: 'POST',
			url: servicios.utilerias.actualizaNodoRestablecer,
			headers: {
				'Content-Type': aplication,
				'Access-Control-Allow-Origin': '*',
				"valor": tiempo,
				"encripta": ""
			}
		}).then(response => {
			this.relojTempo(response);
		});
	}
	relojTempo = (response) => {
		firebase.database().ref("/olvideContrasenia").once("value").then(snapshot => {
			var id = setInterval(() => {
				var data = snapshot.val();
				var minutosCorreo = new Date(Number(response.data.hash)).getMinutes();
				var segundosCorreo = new Date(Number(response.data.hash)).getSeconds();
				var segundosTotalCorreo = (minutosCorreo * 60) + segundosCorreo;
				var fechaActual = new Date();
				var segundosTotalActual = (fechaActual.getMinutes() * 60) + fechaActual.getSeconds();
				if (data.caducidad > (segundosTotalActual - segundosTotalCorreo)) {
					const segundosQ = Number(data.caducidad) - (segundosTotalActual - segundosTotalCorreo);
					let minute = Math.floor((segundosQ / 60) % 60);
					minute = (minute < 10) ? '0' + minute : minute;
					let second = segundosQ % 60;
					second = (second < 10) ? '0' + second : second;
					document.getElementById(TemporizadoClave).innerText = minute + ':' + second + ' minutos';
				} else {
					document.getElementById(TemporizadoClave).innerText = '00:00 minutos';
					claveCaducado = true;
					clearInterval(id);
					$(idModalClave).modal("hide");
				}
			}, 1000);
		});
	}
	resetTimer = () => {
		totalSeconds = 1200000;
		clearInterval(this.interval);
		document.getElementById(TemporizadoClave).innerText = "";
		delete this.interval;
		this.startTimer();
	}
	reenvioEmailClave = () => {
		this.props.setPaso(1);
		goTo("/gnp-olvide-contrasenia");
	}

	render() {
		const modalClaveTempora = "modal-clave-temporal";
		const clvTempVerfi = "Clave de acceso";
		return <div id="passwordOlvide">
			<div>
				<ModalSintillo onClose={this.cierraTooltip} titulo={this.state.titulo}
					show={this.state.showTooltip} type={this.state.type} mensaje={this.state.mensaje}>
				</ModalSintillo>
				<div id="title-Registro">
					<h3 id="txt-titulo-establecer">Establecer nueva contraseña</h3>

				</div>
				<hr className="label-hr" />
				<div className='div-titulo-Olvide'>
					<span className='titulo-Olvide'>Crea una nueva contraseña para ingresar a tu cuenta. </span>
				</div>
				<div className="div-olvide-con">
					<div className="row row-olv">
						<div className={estiloCol} id="campo-password-seguridad" style={{ marginLeft: "5px" }}>
							<Field
								name="password" label="Contraseña" component={campo} max="24" type={this.state.showPass ? "password" : "text"}
								onChange={this.validaPassword} onFocus={this.handleFocusPassword} onBlur={this.handleBlurPassword}
								props={{ param: this.state.showPass, fnToggle: this.toggle.bind(this, "showPass") }}
								error={this.errorT ? "Campo obligatorio" : null}
							/>
							<button type="button" className={this.state.showPass ? ojito : ojitoCerrado} onClick={() => { this.viewPass() }}></button>
							{this.state.showValidatorPass &&
								<div className={modalValidPass}>
									<div className={modalValidPassBody}>
										<span style={{ margin: { estiloColpx }, width: '10%' }} className={this.validaCaracteresIcon('caracteresCompletos')} >
										</span>
										<div className={this.validaCaracteresColor('caracteresCompletos')}>
											<label className="label-text-modal-password">Debe ser al menos de 8 caracteres y máximo 24 caracteres.</label>
										</div>
									</div>
									<div className={modalValidPassBody}>
										<span style={{ margin: { estiloColpx } }} className={this.validaCaracteresIcon('caracterMayuscula')} >
										</span>
										<div className={this.validaCaracteresColor('caracterMayuscula')}>
											<label className="label-text-modal-password">Debe contener al menos una mayúscula.</label>
										</div>
									</div>
									<div className={modalValidPassBody}>
										<span style={{ margin: { estiloColpx }, width: '28px' }} className={this.validaCaracteresIcon('caracteresAlfabeticos')} >
										</span>
										<div className={this.validaCaracteresColor('caracteresAlfabeticos')}>
											<label className="label-text-modal-password">Debe contener al menos cuatro caracteres alfabéticos.</label>
										</div>
									</div>
									<div className={modalValidPassBody}>
										<span style={{ margin: { estiloColpx }, width: '8%' }} className={this.validaCaracteresIcon('caracteresNumericos')} >
										</span>
										<div className={this.validaCaracteresColor('caracteresNumericos')}>
											<label className="label-text-modal-password">Debe contener al menos un caracter numerico.</label>
										</div>
									</div>
									<div className={modalValidPassBody}>
										<span style={{ margin: { estiloColpx }, width: '8%' }} className={this.validaCaracteresIcon('caracterEspecial')} >
										</span>
										<div className={this.validaCaracteresColor('caracterEspecial')}>
											<label className="label-text-modal-password">Debe contener al menos un caracter especial.</label>
										</div>
									</div>
									<div className={modalValidPassBody}>
										<span style={{ margin: { estiloColpx } }} className={this.validaCaracteresIcon('caracterGNP')} >
										</span>
										<div className={this.validaCaracteresColor('caracterGNP')}>
											<label className="label-text-modal-password">No debe contener la palabra GNP.</label>
										</div>
									</div>
									<div className={modalValidPassBody}>
										<span style={{ margin: { estiloColpx }, width: '13%' }} className={this.validaCaracteresIcon('caracterConsecutivoIgual')} >
										</span>
										<div className={this.validaCaracteresColor('caracterConsecutivoIgual')}>
											<label className="label-text-modal-password">No debe contener más de dos caracteres
												consecutivos iguales (p.e. 222, eee).</label>
										</div>
									</div>
									<div className={modalValidPassBody}>
										<span style={{ margin: { estiloColpx }, width: '13%' }} className={this.validaCaracteresIcon('caracterConsecutivo')} >
										</span>
										<div className={this.validaCaracteresColor('caracterConsecutivo')}>
											<label className="label-text-modal-password">No debe contener más de dos caracteres
												consecutivos (p.e. 123, abc).</label>
										</div>
									</div>
									<div className={modalValidPassBody}>
										<span style={{ margin: { estiloColpx } }} className={this.validaCaracteresIcon('espacioEnBlanco')} >
										</span>
										<div className={this.validaCaracteresColor('espacioEnBlanco')}>
											<label className="label-text-modal-password">No debe contener espacios en blanco.</label>
										</div>
									</div>
								</div>}
						</div>
						<div className={estiloCol} id="campo-confPassword-seguridad">
							<Field
								name="confpassword" label="Confirmar contraseña" component={campo} max="24"
								type={this.state.showConfPass ? "password" : "text"} onBlur={this.confirmPassword}
								props={{ param: this.state.showConfPass, fnToggle: this.toggle.bind(this, "showConfPass"), clase: "confpass" }}
							/>
							<button type="button" className={this.state.showConfPass ? ojito : ojitoCerrado} onClick={() => { this.viewPassConf() }}></button>
							{this.state.errorT2 &&
								<div className="error-wrap-olv">
									<p>Campo obligatorio</p>
								</div>
							}
							{this.state.loadingPequeno ? <div className="spinner" id="spinner-validacion-poliza" style={{ right: '-33px' }}></div> : null}
						</div>
					</div>
					<div className="row row-olv">
						<div className="col-md-2">
							<button id="btn-continuar-seguridad" className="orange-rectangle" onClick={this.siguiente}
								style={{ width: '120px', height: '48px', fontSize: '16px', padding: '14px 16px', marginTop: '34px', marginLeft: "10px" }}
							>Continuar</button>
						</div>
					</div>
				</div>
				<div className="modal modal-msj fade" id="modal-exito" tabIndex="-1" role="dialog" aria-labelledby="modal-exitoLabel"
					data-backdrop="static" data-keyboard="false">
					<div className="modal-dialog modal-dialog-olv-exito" role="document">
						<div className="modal-content modal-content-olv-exito">
							<div className="modal-cabecera-olv-exito">
								<div className="icono icono-olv-exito">
									<span className='icon-circle-dove icono-modal-olvide olv-i' ></span>
								</div>
								<div className="titulo-exito">
									<h5 className="text-center" id="modal-nuevo-exitoLabel">Contraseña actualizada</h5>
								</div>
							</div>
							<div className="txt-black-olv-exito"><p>
								Tu información se ha guardado satisfactoriamente.
								De ahora en adelante deberás acceder a tu sesión con tu nueva contraseña.</p>
							</div>
							<button type="button" className="btn orange-btn btn-olv-exito" data-dismiss="modal" style={{ "marginRight": "50px" }} onClick={this.ir}>Acceder ahora</button>
						</div>
					</div>
				</div>
				<div className="modal fade" id={modalClaveTempora} tabIndex="-1" role="dialog" aria-labelledby={modalClaveTempora}>
					<div className="modal-dialog modal-clave-temporal" id="modal-clave-temporal" role="document">
						<div className="modal-content modal-content-clave">
							<div className="modal-header-clave">
								<h4 id={modalClaveTempora}>{clvTempVerfi}</h4>
							</div>
							<div className="modal-body-clave">
								<div className="modal-body-clave-title">
									<label>
										<span>Recibirás un mensaje de texto SMS al número </span>
										<span style={{ marginTop: "8px" }}>
											{this.state.modalTelefono}
										</span><br></br>
										<span> y al correo electrónico </span>
										<span style={{ textTransform: "lowercase", marginTop: "8px" }}>  {this.state.modalCorreo} </span>
									</label>
									{this.state.MsjTiempoRestante ?
										<div className="alerta-clave-temp">
											<div className="alerta-body-clave">
												<label className="label-title-alerta-clave">
													<img src={iconTimer} style={{ marginRight: "21px" }} />
													Tiempo restante
												</label>
												<label id={TemporizadoClave}></label>
											</div>
										</div> : null}
									<div className="input-wrap input-codigo-verificacion">
										<CampoFieldFrm style={{ fontSize: "12px !important", padding: "0px 16px !important" }}
											name="codigo_verificacion" type="text"
											max="8" label={clvTempVerfi} id="codigo_verificacion"
											error={this.state.errorsCodigo ? this.state.msjaMostrar : null}
										></CampoFieldFrm>
									</div>
									{this.state.msjErrorServicio ?
										<div className="alerta-otp" style={{ "background": "#FDF3F5", "height": "auto" }}>
											<div>
												<span className="icon-equis-circulo" style={{ 'cursor': 'pointer' }} onClick={this.quitarmsjErrorServicio.bind(this, false)}></span>
											</div>
											<div className="alerta-body">
												<label className="label-title-alerta-error">Error</label>
												<label className="label-text-alerta">Ocurrio un error, intente más tarde.</label>
											</div>
										</div> : null}
									{this.state.msjExitoReenvio ?
										<div className="alerta-otp" style={{ height: 'auto', background: '#E3F5EB' }}>
											<div> <span className="icon-circle-dove" style={{ margin: '25px 8px' }}></span> </div>
											<div className="alerta-body">
												<label className="label-title-alerta" style={{ color: '#44956C' }}>CÓDIGO REENVIADO</label>
												<label className="label-text-alerta">Se ha reenviado el código exitosamente.</label>
											</div>
											<div>
												<span className="icono-cerrar-sintillo" style={{ 'cursor': 'pointer', color: '#44956C !important' }}
													onClick={this.quitarmsjReenvio.bind(this, false)}></span>
											</div>
										</div> : null}
									<div className="footer-modal-clave-temporal">
										<div className="boton-text-final-clave">
											<button onClick={this.codigoCompleto.bind(this)}
												style={{ "color": "#FFFFFF" }} type="button"
												className="orange-btn texto-otp" id="btn-validar-clave"
											>Validar código</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				{<ModalOpcionesAyuda></ModalOpcionesAyuda>}
				{<BtnAyuda></BtnAyuda>}

				{claveCaducado === true && <ModalClaveExpirado></ModalClaveExpirado>}
			</div>
		</div>;
	}
}

PasswordForm = reduxForm({ form: "datosPassword" })(PasswordForm);
export default connect(mapState, mapDispatch)(PasswordForm);



// WEBPACK FOOTER //
// ./src/gnp-recuperar-contrasenia/password.frm.js